/*
 * Welcome to your app's main JavaScript file!
 *
 * We recommend including the built version of this JavaScript file
 * (and its CSS file) in your base layout (base.html.twig).
 */

// any CSS you import will output into a single css file
import './scss/screen.scss';

import { Collapse, Dropdown } from 'bootstrap';

import './js/swiper.js';

import './js/fancybox.js';

import './js/google.js';

import './js/nice-select.js';

import './js/plyr.js';

import { Splide } from '@splidejs/splide';
import '@splidejs/splide/dist/css/splide.min.css';
window.Splide = Splide;

import Accordion from './js/accordion.js';
window.Accordion = Accordion;

import PaySafe from './js/modules/paysafe.js';
window.PaySafe = PaySafe;

document.querySelectorAll('a[target=_blank]').forEach((a) => {
  const rel = a.rel ? a.rel.split(' ') : [];

  if (rel.includes('noopener')) {
    return;
  }

  rel.push('noopener');

  a.rel = rel.join(' ');
});
